<app-thi-page-shell [lang]="landingLang">
  <div class="overflow-hidden">
    <section class="relative pt-40 pb-24 thi-section-gradient-soft overflow-hidden">
      <div class="container mx-auto px-4 relative z-10">
        <div class="max-w-4xl mx-auto text-center">
          <h1 class="text-4xl md:text-5xl font-bold text-foreground mb-6">{{ t.about.title }}</h1>
          <p class="text-xl text-muted-foreground">{{ t.about.subtitle }}</p>
        </div>
      </div>
    </section>

    <section class="py-24 bg-background">
      <div class="container mx-auto px-4 max-w-4xl">
        <div class="space-y-16">
          <div class="bg-card border border-border rounded-2xl p-8">
            <h2 class="text-2xl font-bold text-foreground mb-4">{{ t.about.story }}</h2>
            <p class="text-muted-foreground text-lg leading-relaxed">{{ t.about.storyText }}</p>
          </div>
          <div class="thi-surface-gradient-vision border border-primary/20 rounded-2xl p-8">
            <h2 class="text-2xl font-bold text-foreground mb-4">{{ t.about.vision }}</h2>
            <p class="text-muted-foreground text-lg leading-relaxed">{{ t.about.visionText }}</p>
          </div>
          <div>
            <h2 class="text-2xl font-bold text-foreground mb-8 text-center">{{ t.about.values }}</h2>
            <div class="grid md:grid-cols-3 gap-8">
              <div
                *ngFor="let v of values"
                class="bg-card border border-border rounded-2xl p-6 text-center hover:shadow-lg hover:border-primary/20 transition-shadow duration-200"
              >
                <div class="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <i [class]="'text-2xl text-primary ' + v.icon"></i>
                </div>
                <h3 class="font-bold text-foreground mb-2">{{ valueTitle(v.titleKey) }}</h3>
                <p class="text-muted-foreground text-sm">{{ valueDesc(v.titleKey) }}</p>
              </div>
            </div>
          </div>
          <div class="text-center">
            <a routerLink="/register" class="thi-btn-primary-lg group inline-flex">
              {{ t.hero.ctaPrimary }}
              <i
                class="transition-transform group-hover:translate-x-1 rtl:group-hover:-translate-x-1"
                [ngClass]="arrowIcon"
              ></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</app-thi-page-shell>
